import { ClientContactTag } from '@bb/contacts';
import { BasicContact } from '@bb/domain/dist/types';
import { Avatar, CLIENT_CONTACT_TAGS } from 'components';
import React from 'react';
import {
  Container,
  FullProfileName,
  InfoContainer,
  NameContainer,
  RolesContainer,
  RoleTag,
  EmployerContainer,
  CompanyText,
} from './common';

export type CoopProfileProps = {
  contact: BasicContact;
};

const CoopProfile: React.FC<CoopProfileProps> = ({ contact }) => (
    <Container>
      <InfoContainer>
        <Avatar user={contact} width={36} />
        <NameContainer data-cy="contact-details-name-container">
          <FullProfileName level={2}>
            {`${contact.firstName} ${contact.lastName || ''}`.trim()}
          </FullProfileName>
        </NameContainer>
        <RolesContainer data-cy="contact-details-role-container">
          <RoleTag color="blue">
            {CLIENT_CONTACT_TAGS[
              ClientContactTag.Buyer
            ].label.toLocaleLowerCase()}
          </RoleTag>
        </RolesContainer>
        <EmployerContainer>
          <CompanyText>{contact.org.name}</CompanyText>
        </EmployerContainer>
      </InfoContainer>
    </Container>
  );

export default CoopProfile;
